import { Box, HStack, Text } from '@chakra-ui/react';
import React from 'react';

import { InfoIcon } from '@/imports/ui/chakra/feather';

interface SignInWarningProps {
  canSignUp: boolean;
}

export const SignInWarning: React.FC<SignInWarningProps> = ({ canSignUp }) => {
  return (
    <Box
      p="3"
      bg="blue.50"
      borderRadius="lg"
      border="1px solid"
      borderColor="blue.200"
    >
      <HStack spacing="2">
        <InfoIcon boxSize="4" color="blue.500" />
        <Box flex="1">
          <Text fontSize="sm" color="blue.700" fontWeight="medium">
            Sign in to continue
          </Text>
          <Text fontSize="xs" color="blue.600" mt="1">
            {canSignUp
              ? 'Sign in or create an account to register for this event.'
              : 'Sign in to register for this event.'}
          </Text>
        </Box>
      </HStack>
    </Box>
  );
};